import axios from 'axios'
import {Notify} from 'vant'
import i18n from '../i18n'
import token from '@/plugins/token'
import router from '@/router'
import whiteList from './whiteList'
import * as session from '@/plugins/session'

const service = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  }
})

const goLogin = function(){
  let uid = sessionStorage.getItem('user_uid')
  if(uid === null){
    session.clean()
    router.go(0)
  }else{
    session.clean()
    router.go(0).then(()=>{
      sessionStorage.setItem('tip_msg',i18n.t('error.axios.401'))
    })
  }
}

const urlWhiteList = ['/startSession']

service.interceptors.request.use(
  config => {
    if (!urlWhiteList.includes(config.url)) {
      if(!whiteList.includes(config.url)){
        config.headers.token = token.create()
      }
      config.headers.ssid = sessionStorage.getItem('ss_id')
      const { 'Content-Type': contentTypeValue } = config.headers
      if(contentTypeValue !== null && contentTypeValue !== undefined && contentTypeValue === 'application/json'){
        config.data = {data:token.encryption(config.data)}
      }
    }
    config.headers.language = i18n.locale
    config.url = '/api' + config.url
    return config
  },
  error => {
    return error
  }
)

service.interceptors.response.use(
  response => {
    const resp = token.decode64(response.data)
    const res = JSON.parse(resp)
    //const res = response.data
    if (res.successful) {
      if (res.message) {
        Notify({type: 'success', message: res.message})
      }
      return res.data
    } else {
      Notify({type: 'danger', message: res.message})
    }
    return null
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
      case 400: Notify({ type: 'danger', message: i18n.t('error.axios.400') }); break
      case 401: goLogin(); break
      case 403: Notify({ type: 'danger', message: i18n.t('error.axios.403') }); break
      case 404: Notify({ type: 'danger', message: i18n.t('error.axios.404') }); break
      case 408: Notify({ type: 'danger', message: i18n.t('error.axios.408') }); break
      case 500: Notify({ type: 'danger', message: i18n.t('error.axios.500') }); break
      case 501: Notify({ type: 'danger', message: i18n.t('error.axios.501') }); break
      case 502: Notify({ type: 'danger', message: i18n.t('error.axios.502') }); break
      case 503: Notify({ type: 'danger', message: i18n.t('error.axios.503') }); break
      case 504: Notify({ type: 'danger', message: i18n.t('error.axios.504') }); break
      case 505: Notify({ type: 'danger', message: i18n.t('error.axios.505') }); break
      default: break
      }
      return
    }
  }
)

export default service
